<template>
    <div>
        <!-- HEAD -->

        <div class="head row p-0 g-0" data-aos="fade-in" data-aos-delay="100" data-aos-duration="3000" >
            <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0">
                <img :src="`${publicPath}img/01personas.jpg`" class="img-responsive">
            </div>
            <div class="headRight p-3 pt-xl-2 px-xl-5 px-xxl-0 ps-xxl-5">
                <div class="row justify-content-end">
                    <div class="col-2 m-0 me-3  mb-4 mt-3 p-0">
                        <img :src="`${publicPath}img/01personas-headIcon.gif`" class="img-responsive">
                    </div>
                </div>
                <h2>{{ $t('personas.title') }}</h2>
                <p class="text-end pt-2 pt-xl-3">{{ $t('personas.txt') }}</p>
            </div>
        </div>

        <!-- end HEAD -->

        <div class="contingut bg-white row g-0">
            <div class="row g-0">
                <div class="col-12 col-lg-10 m-auto pb-3">

                    <div class="col-12 my-0 my-lg-5 py-5 border-bottom position-relative  bg-darkBlue">
                        <div class="row align-items-top my-3">
                            <div class="col-11 col-xxl-10 m-auto">
                                <img :src="`${publicPath}img/01personasLogo.png`" class="img-responsive">
                                <div class="row g-0 justify-content-center" data-aos="fade-in" data-aos-duration="1000">
                                    <hr class="bg-Blue mb-5 mt-4">
                                    <div class="col-12 col-md-6 col-lg text-center">
                                        <p class="numbersPersonas text-white">
                                            <AnimatedNumber
                                            ref='counter_programas'
                                            :startAmount='0'
                                            :endAmount='1306'
                                            :duration='3'
                                            prefix=''
                                            suffix=''
                                            :separator=separator
                                            decimalSeparator=','
                                            :decimals='0'
                                            :autoinit='true'
                                            />
                                        </p>
                                        <h5 class="text-white">{{ $t('personas.programas') }}</h5>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg text-center">
                                        <p class="numbersPersonas text-white">
                                            <AnimatedNumber
                                            ref='counter_formacions'
                                            :startAmount='0'
                                            :endAmount='197034'
                                            :duration='3'
                                            prefix=''
                                            suffix=''
                                            :separator=separator
                                            decimalSeparator=','
                                            :decimals='0'
                                            :autoinit='true'
                                            />
                                        </p>
                                        <h5 class="text-white">{{ $t('personas.horas') }}</h5>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg text-center">
                                        <p class="numbersPersonas text-white">
                                            <AnimatedNumber
                                            ref='counter_participantes'
                                            :startAmount='0'
                                            :endAmount='17405'
                                            :duration='3'
                                            prefix=''
                                            suffix=''
                                            :separator=separator
                                            decimalSeparator=','
                                            :decimals='0'
                                            :autoinit='true'
                                            />
                                        </p>
                                        <h5 class="text-white">{{ $t('personas.participantes') }}</h5>
                                    </div>
                                    <div class="col-12 col-md-6 col-lg text-center">
                                        <p class="numbersPersonas text-white">
                                            <AnimatedNumber
                                            ref='counter_niveles'
                                            :startAmount='0'
                                            :endAmount='9'
                                            :duration='3'
                                            prefix=''
                                            suffix=''
                                            separator='.'
                                            decimalSeparator=','
                                            :decimals='0'
                                            :autoinit='true'
                                            />
                                        </p>
                                        <h5 class="text-white" v-html="$t('personas.nivel')"></h5>
                                    </div>
                                    <hr class="bg-Blue mb-5 mt-4">
                                </div>
                                <div class="row g-0 justify-content-center" data-aos="fade-in" data-aos-duration="1000">
                                    <h3 class="text-turquesa">{{ $t('personas.nuevos') }}</h3>
                                    <p class="text-white mt-3">{{ $t('personas.ante') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr class="bg-Blue my-0 my-lg-5">

                    <div class="row justify-content-between g-0 pt-5 pb-1">
                        <div class="col-12 col-lg-5 text-center text-lg-start px-3 px-lg-0 pe-3 pe-xxl-5" data-aos="fade-up" data-aos-duration="600">
                            <h3 class="text-blau pb-3 pe-3 pe-lg-5">{{ $t('personas.certificado') }}</h3>
                            <p>{{ $t('personas.filial') }}</p>
                            <p>{{ $t('personas.resultados') }}</p>
                        </div>
                        <div class="col-12 col-lg-6 text-end" data-aos="fade-up" data-aos-duration="1000">
                            <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel" data-bs-wrap="false" >
                                <div class="carousel-inner">
                                    <div class="carousel-item active" data-bs-interval="2500" >
                                        <img :src="`${publicPath}img/01personasClasse.jpg`" class="img-responsive mb-4">
                                    </div>
                                    <div class="carousel-item" data-bs-interval="2500">
                                        <img :src="`${publicPath}img/01personasClasse2.jpg`" class="img-responsive mb-4">
                                    </div>
                                    <div class="carousel-item" data-bs-interval="2500">
                                        <img :src="`${publicPath}img/01personasClasse3.jpg`" class="img-responsive mb-4">
                                    </div>
                                </div>
                                <button class="carousel-control-prev d-none d-lg-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                    <img :src="`${publicPath}img/carouselBack.png`" class="img-responsive">
                                    <span class="visually-hidden">Previous</span>
                                </button>
                                <button class="carousel-control-next d-none d-lg-block" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                    <img :src="`${publicPath}img/carouselNext.png`" class="img-responsive">
                                    <span class="visually-hidden">Next</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="contingut bg-white row g-0 mb-5 pb-5">
            <div class="col-12 mt-5 py-5 mb-5 fonsGris position-relative">
                <h3 class="pb-3 mb-3">{{ $t('contribucion-a-los-ods') }}</h3>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-2 col-md-auto mb-4 text-center text-lg-start">
                        <p>{{ $t('impacto-directo') }}</p>
                        <img :src="`${publicPath}img/01transformacion-icono01.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01crecimiento-icono03.gif`" class="img-responsive m-1">
                    </div>
                    <div class="col-md-auto border-start mb-4 text-center text-lg-start">
                        <p>{{ $t('impacto-in-directo') }}</p>
                        <img :src="`${publicPath}img/01personas-icono03.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01personas-icono04.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01crecimiento-icono05.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01crecimiento-icono06.gif`" class="img-responsive m-1">
                        <img :src="`${publicPath}img/01transformacion-icono08.gif`" class="img-responsive m-1">
                    </div>
                </div>
            </div>

            <hr>
            <div class="row p-0 g-0">
                <div class="col-12 p-3 p-lg-0 m-0 pb-3 text-start">
                    <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/sostenibilidad"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.sostenibilidad") }}</localized-link>
                </div>
            </div>

        </div>

    </div>
</template>
<script>
    import AnimatedNumber from 'vue3-autocounter'

    export default {
        name: "PersonasView",
        components: {
            AnimatedNumber,
        },
        data() {
            return {
                publicPath: process.env.BASE_URL,
                separator: '.'
            }
        },
        mounted() {
            document.addEventListener('aos:in:start-counter-personas', this.startCounter);
            if(this.$i18n.locale=="es"){
              this.separator = '.';
            } else {
              this.separator = ',';
            }

        },
        methods: {
            startCounter() {
              if (this.$refs.counter_programas != null) {
                this.$refs.counter_programas.start();
              }
              if (this.$refs.counter_formacions != null) {
                this.$refs.counter_formacions.start();
              }
              if (this.$refs.counter_participantes != null) {
                this.$refs.counter_participantes.start();
              }
              if (this.$refs.counter_niveles != null) {
                this.$refs.counter_niveles.start();
              }
            }
        }
    }

</script>
